import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useAuth } from "../../../Context/authContext";
import TextField from "../../../Components/TextField";
import Button from "../../../Components/Button";
import { Typography } from "../../../Components/Typography";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    const result = await login((email || '').trim().toLowerCase(), password);
    if (result?.success) {
      const userRole = result.user?.role?.toLowerCase()?.trim();
      const isProfileCompleted = result.user?.is_profile_completed;

      // Admin: always to admin dashboard
      if (userRole === 'admin') {
        navigate("/admin-dashboard");
        return;
      }
      // Mentor: to mentor dashboard (route guard redirects to complete-registration if needed)
      if (userRole === 'mentor') {
        navigate("/mentor-dashboard");
        return;
      }
      // Investor, ecosystem_partner, corporate_sponsor: if profile incomplete, go to complete-registration (same as mentor flow)
      if (userRole === 'investor' || userRole === 'ecosystem_partner' || userRole === 'corporate_sponsor') {
        if (isProfileCompleted === false) {
          navigate("/complete-registration");
        } else {
          navigate("/");
        }
        return;
      }
      navigate("/");
    } else {
      setError(result?.error || "Unable to login. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg bg-white shadow-lg rounded-2xl border border-slate-200 p-8 flex flex-col gap-6">
        <div className="flex flex-col items-center gap-4 text-center">
          <div>
            <img src="/ign-logo.svg" alt="IgniteNext Logo" className="h-15 w-50" />
          </div>
          <div>
            <Typography as="h1" className="text-2xl font-bold text-primary-900">
              Welcome back
            </Typography>
            <Typography as="p" className="text-sm text-tertiary-600 mt-1">
              Sign in to continue to IgniteNext.
            </Typography>
          </div>
        </div>

        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <TextField
            label="Email or Username"
            name="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email or username"
            required
            autoFocus
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            showPasswordToggle
          />

          {error && (
            <div className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-600">
              <Icon icon="lucide:alert-circle" className="h-4 w-4" />
              <span>{error}</span>
            </div>
          )}

          <Button type="submit" fullWidth disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <div className="flex items-center justify-between text-sm text-tertiary-600">
          <Link to="/forgot-password" className="text-brand-blue hover:underline">
            Forgot password?
          </Link>
          <span>
            New here?{" "}
            <Link to="/signup" className="text-brand-blue hover:underline">
              Create account
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;

